interface Props {
  activeColor: string;
}
const JobsIcon = (props: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6V5C9 3.9 9.9 3 11 3H13C14.1 3 15 3.9 15 5V6H19C20.1 6 21 6.9 21 8V18C21 19.1 20.1 20 19 20H5C3.9 20 3 19.1 3 18V8C3 6.9 3.9 6 5 6H9ZM11 5V6H13V5H11Z"
        fill={props.activeColor}
        stroke={props.activeColor}
      />
      <path d="M3 12H21" fill={props.activeColor} stroke={props.activeColor} />
    </svg>
  );
};

export default JobsIcon;
